
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { DataGridPro, GridColDef, GridRowsProp, GridSortModel } from '@mui/x-data-grid-pro';
import { OptionsPopper, StripedGridRow, features, gridSx, paginationSx, GridColumn } from './grid-settings';
import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import { Link, Typography } from '@mui/material';

export interface GridProps {
    dataTestId: string;
    columns: GridColDef[];
    sortModel: GridSortModel;
    items: Array<any>;
}

export const CustomGrid = ({
    dataTestId,
    columns,
    sortModel,
    items
}: GridProps) => {

    const translate = useTranslation();

    const initialState: GridInitialStatePro = {
        pagination: {
            paginationModel: { pageSize: 10, page: 0 },
        },
        sorting: {
            sortModel: sortModel,
        },
    }

    const rows: GridRowsProp = items.map((item, index) => {
        return {
            id: index,
            ...item,
        };
    });

    const cols: GridColDef[] = columns.map((column, index) => {
        return {
            display: 'flex',
            ...column,
        }
    });

    return (
        <DataGridPro
            data-testid={dataTestId}
            autoHeight
            rows={rows}
            columns={cols}
            pagination={true}
            pageSizeOptions={[5, 10, 25]}
            initialState={initialState}
            sx={gridSx}
            slots={{
                row: StripedGridRow,
                basePopper: OptionsPopper
            }}
            slotProps={{
                pagination: {
                    sx: paginationSx,
                    labelRowsPerPage: translate('Show:')
                },
                columnsPanel: {
                    sx: { "& .MuiIconButton-sizeSmall": { fontSize: '14px' } }
                },
            }}
            {...features}
        />
    );
}

export const getColumnLink = (value: string, columnHeader: string, linkBase: string, alternativeMsg: string, onClickFunc?: any) => {
    if (!value || value.length == 0) {
        return (
            <Typography variant='body1'>
                {alternativeMsg}
            </Typography>
        )
    }

    return (
        <Typography variant='body1'>
            <Link
                href={linkBase + value}
                onClick={() => onClickFunc(columnHeader, value)}
                sx={{ letterSpacing: '0.5px' }}
            >
                {value}
            </Link>
        </Typography>
    );
}

export const createColumn = (column: GridColumn, flex = 1): GridColDef =>
    ({ field: column.field, headerName: column.header, flex });

